import { createAction } from '@reduxjs/toolkit';

export const editUserMultiple = createAction('betslip/userMultiples/editUserMultiple');
